export default "__VITE_PUBLIC_ASSET__600cabfa__"